export default __webpack_public_path__ + "static/media/CAMO_Final_Logo.b0272828.svg";